<template>
    <div>
        <router-view v-if="detailed" />
        <NotFound v-else />
    </div>
</template>

<script>
import NotFound from '@/components/common/NotFound.vue';

export default {
    name: 'Promotion',
    components: {
        NotFound,
    },
    computed: {
        detailed() {
            return this.$route.name !== 'Promotion';
        },
    },
};
</script>
